/** The on-screen pill for a merge-field chip — see merge-field-node.ts for the storage-side serialization. */

import { NodeViewWrapper, type ReactNodeViewProps } from '@tiptap/react';
import type { MergeFieldAttrs } from './merge-field-node.js';

export function MergeFieldChip({ node }: ReactNodeViewProps) {
  const attrs = node.attrs as MergeFieldAttrs;
  return (
    <NodeViewWrapper as="span" className="merge-field-chip" contentEditable={false}>
      {attrs.label || attrs.token}
    </NodeViewWrapper>
  );
}
